<template>
  <div>
    <b-table
      class="tab-b"
      :items="directions"
      :fields="fields"
      ref="selectableTable"
      selectable
      :select-mode="selectMode"
      @row-selected="onRowSelected"
      :tbody-tr-class="rowClass"
      responsive="sm"
    >
    </b-table>
    <template v-if="selectedOptions.isAdded">
      <b-row v-show="selectedOptions.isAdded">
        <b-col lg="4" sm="4" xs="12">
          <b-form-group label="Departamento *" label-for="input-group-dep">
            <b-form-select
              id="input-group-dep"
              v-model="selectedDepartment"
              @change="getProvince"
              required
            >
              <option :value="null">Seleccione el Departamento</option>
              <option
                v-for="departament in listDepartments"
                :value="departament"
                :key="departament.id"
              >
                {{ departament.text }}
              </option>
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col lg="4" sm="4" xs="12">
          <b-form-group label="Provincia *" label-for="input-group-prov">
            <b-form-select
              id="input-group-prov"
              v-model="selectedProvince"
              @change="getDistrict"
              required
            >
              <option :value="null">Seleccione la provincia</option>

              <option
                v-for="province in listProvinces"
                :value="province"
                :key="province.id"
              >
                {{ province.text }}
              </option>
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col lg="4" sm="4" xs="12">
          <b-form-group label="Distrito *" label-for="input-group-dist">
            <b-form-select
              id="input-group-dist"
              v-model="selectedDistrict"
              :options="listDistricts"
              required
            >
              <b-form-select-option :value="null"
                >Seleccione una opción
              </b-form-select-option>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="3">
          <b-form-group
            id="input-group-4"
            label="Tipo de Vivienda *"
            label-for="input-4"
          >
            <b-form-select
              id="input-4"
              v-model="typeHousing"
              :options="optionsType"
              required
            >
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col lg="4" sm="5" xs="12">
          <b-form-group label="Dirección *" label-for="input-5">
            <b-form-input id="input-5" type="text" v-model="directionValue" />
          </b-form-group>
        </b-col>
        <b-col lg="5" sm="4" xs="12">
          <b-form-group label="Referencia *" label-for="input-6">
            <b-form-input id="input-6" type="text" v-model="referenceValue" />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="2" md="2">
          <b-form-group label="Nro./Mz./Bloq.*" label-for="input-18">
            <b-form-input
              id="input-18"
              v-model.number="numberAdress"
              type="text"
              required
              placeholder="Ingrese el número"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="2" md="2">
          <b-form-group label="Dep./Int./Lt." label-for="input-120">
            <b-form-input
              id="input-120"
              v-model="numDepartament"
              type="text"
              required
            ></b-form-input>
          </b-form-group>
        </b-col>
        
        <b-col cols="2" md="2">
          <b-form-group label="Piso *" label-for="input-18">
            <b-form-input
              id="input-18"
              v-model.number="numFloor"
              type="text"
              required
              placeholder="Ingrese el número"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
    </template>

    <b-row>
      <b-col cols="6" class="text-right">
        <b-button class="btn-white" @click="addDirection">
          <font-awesome-icon icon="plus" /> Agregar
        </b-button>
      </b-col>
      <b-col cols="6" class="text-left">
        <b-button
          :disabled="isRowSelected"
          class="btn-white"
          @click="createDirection"
        >
          <font-awesome-icon icon="plus" />
          Guardar
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import axios from "axios";
import { mapState } from "vuex";
export default {
  name: "ModalDirecciones",
  data() {
    return {
      numberAdress:"",
      numFloor:"",
      numDepartament:"",
      typeHousing: "Casa / Departamento",
      optionsType: ["Casa / Departamento", "Oficina", "Otros"],
      rowEdited: null,
      fields: [
        { key: "selected", label: "  " },
        { key: "department", label: "Departamento" },
        { key: "province", label: "Provincia" },
        { key: "district", label: "Distrito" },
        { key: "street", label: "Dirección" },
        { key: "reference", label: "Referencia" },
        { key: "actions", label: "  " },
      ],
      selectMode: "single",
      selected: [],
      listDepartments: [],
      listDistricts: [],
      listProvinces: [],
      directionValue: "",
      referenceValue: "",
      selectedDepartment: null,
      selectedDistrict: null,
      selectedProvince: null,
      selectedOptions: {
        isAdded: false,
      },
      dataDirections: [],
    };
  },
  props: {
    directions: {
      type: Array,
    },
    selectedDirection: {
      type: Object,
    },
    id: {
      type: Number,
    },
  },
  computed: {
    ...mapState("module", ["token"]),
    isRowSelected() {
      if (this.referenceValue.length == 0 && this.directionValue.length == 0)
        return true;
      else return false;
    },

    highestPriority() {
      if (this.directions.length == 0) return false;
      return this.directions.reduce((a, b) =>
        Number(a.priority) > Number(b.priority) ? a : b
      );
    },
  },
  created() {
    this.getDepartments();
  },
  methods: {
    async getDepartments() {
      try {
        // this.$store.commit("SET_LOADING", true);
        let response = await axios.get(
          process.env.VUE_APP_LOCALIZATION_BASE + "/departments?limit=50&page=1",
          {
            headers: {
              "Content-type": "application/json",
              "Authorization": "Bearer "+ this.token
            },
          }
        );
        const data = response.data.map((row) => {
          return {
            value: row.id,
            text: row.description,
          };
        });
        this.listDepartments = data;
      } catch (error) {
        console.log(error);
      } finally {
        // this.$store.commit("SET_LOADING", false)
      }
    },
    async getProvince(e) {
      try {
        let response = await axios.get(
          process.env.VUE_APP_LOCALIZATION_BASE +
            "/departments/" +
            e.value +
            "/provinces",
            {
            headers: {
              "Content-type": "application/json",
              "Authorization": "Bearer "+ this.token
            },
          }
        );
        const data = response.data.map((row) => {
          return {
            value: row.id,
            text: row.description,
          };
        });
        this.listProvinces = data;
      } catch (error) {
        console.log(error);
      }
    },
    async getDistrict(e) {
      try {
        this.$store.commit("SET_LOADING", true);
        let response = await axios.get(
          process.env.VUE_APP_LOCALIZATION_BASE +
            "/provinces/" +
            e.value +
            "/districts",
            {
            headers: {
              "Content-type": "application/json",
              "Authorization": "Bearer "+ this.token
            },
          }
        );

        const data = response.data.map((row) => {
          return {
            value: {
              id: row.id,
              ubigeo: row.ubigeo,
              description: row.description,
            },
            text: row.description,
          };
        });
        this.listDistricts = data;
      } catch (error) {
        console.log(error);
      } finally {
        this.$store.commit("SET_LOADING", false);
      }
    },
    addDirection() {
      this.selectedOptions.isAdded = !this.selectedOptions.isAdded;
      const mayorPriority = this.highestPriority
        ? this.highestPriority.priority + 1
        : 0;
      let randomNumber = Math.floor(new Date().getTime() / 1000);
      this.dataDirections.push({
        clientId: this.id,
        dadId: 1,
        department: "",
        district: "",
        id: randomNumber,
        number: "",
        priority: mayorPriority,
        province: "",
        reference: "",
        street: "",
        ubigeo: "",
        typeHousing: "",
        numFloor:"",
        numDepartament:""
      });
    },

    onRowSelected(items) {
      this.$emit("update:selectedDirection", items[0]);
      this.$bvModal.hide("modal-dir");
    },
    async createDirection() {
      try {
        this.dataDirections[0].department = this.selectedDepartment.text;
        this.dataDirections[0].province = this.selectedProvince.text;
        this.dataDirections[0].district = this.selectedDistrict.description;
        this.dataDirections[0].ubigeo = this.selectedDistrict.ubigeo;
        this.dataDirections[0].street = this.directionValue;
        this.dataDirections[0].reference = this.referenceValue;
        this.dataDirections[0].typeHousing = this.typeHousing;
        this.dataDirections[0].numDepartament=this.numDepartament;
        this.dataDirections[0].numFloor= this.numFloor;
        this.dataDirections[0].number=this.numberAdress;
        let dataSend = this.dataDirections[0];
        console.log(dataSend);

        this.$store.commit("SET_LOADING", true);
        let response = await axios.post(
          process.env.VUE_APP_CLIENT_CORE_BASE + "/directions",
          dataSend,
          {
            headers: {
              "Content-type": "application/json",
              "Authorization": "Bearer "+ this.token
            },
          }
        );
        let values = {
          variant: "success",
          msg: "Se ha creado exitosamente !",
        };
        this.$store.commit("SET_ERROR_MSG", values);
        this.$store.commit("setShowAlert", true);
        this.selectedOptions.isAdded = false;
        this.$emit("update", response.data);
      } catch (error) {
        console.log(error);
      } finally {
        this.$store.commit("SET_LOADING", false);
        setTimeout(() => this.$store.commit("setShowAlert", false), 3000);
      }
    },

    rowClass(item, type) {
      if (!item || type !== "row" || !this.selectedDirection) return;
      if (item.id == this.selectedDirection.id) return "table-success";
    },
  },
};
</script>

<style scoped>
.text-right {
  text-align: right;
}
.padding-five-bottom {
  margin-bottom: 3%;
}
.btn-padding {
  padding: 0.375rem 1.5rem 0.375rem 1.5rem !important;
}
::v-deep .b-table thead {
  background-color: transparent !important;
  color: black !important;
  font-weight: 500 !important;
  border: none !important;
}
::v-deep .b-table thead th {
  font-weight: 700 !important;
  border: none !important;
  font-size: 11pt;
}
.bg-red {
  background: #ff4c4c;
}
.color-white {
  color: white;
}
.width-10 {
  width: 21px;
  height: 23px;
}
.border-gray {
  border: 1px solid gray;
}

.bg-white {
  background: white;
  border-color: gray;
}
.border-color {
  border-color: rgb(254, 123, 1);
}
.color-orange {
  color: rgb(254, 123, 1) !important;
}
.bg-orange {
  background: rgb(254, 123, 1) !important;
}
.text-center {
  text-align: center;
}
</style>
